import axios from 'axios'
import join from 'url-join'

import { getApirAddr, getCompanyInfo } from './api'

let token = localStorage.getItem('token')

const updateToken = () => {
  token = localStorage.getItem('token')
}
export let apir = null
export let cinfo = null
const haxios = axios.create()
const isAbsoluteURLRegex = /^(?:\w+:)\/\//

export const getToken = async (username, password, shouldNavigate = true) => {
  try {
    const res = await axios({
      method: 'POST',
      url: `https://api.aa-vision.com/api/authenticate`,
      data: { Username: username, Password: password },
      headers: { 'Content-Type': 'application/json' }
    })

    const token = res.data.token
    localStorage.setItem('token', token)
    updateToken()
    return res
  } catch (error) {
    console.error('Error getting token', error)

    const status = error?.response?.status

    if (status === 406 && shouldNavigate) {
      if (window.location.pathname !== '/login') window.location.href = '/login'
    }

    return null
  }
}


export const getCinfo = async () => {
  if (cinfo) return cinfo
  cinfo = await getCompanyInfo()
  return cinfo
}

export const getApir = async () => {
  if (apir) return apir // Return apir if it's already set
  if (!cinfo) return null // Return null if cinfo isn't available
  const res = await getApirAddr(cinfo.CompanyID)

  // Allow localhost, dev server IP, and dashboard domain
  const allowedHostnames = ['localhost', '139.162.228.207', 'dashboard.connectplus.parts'];
  if (!allowedHostnames.includes(window.location.hostname)) {
    if (window.location.hostname !== res.CompanyDomain) {
      throw new Error('This is not your server.')
    }
  }

  apir = `https://${res.CompanyDomain}/api`
  console.log('APIR:', apir)

  if (!apir) {
    window.location.href = '/error'
  }

  return apir // Return the apir value after fetching it
}

export const clearCachedData = () => {
  apir = null
  cinfo = null
  token = null
  localStorage.removeItem('token')
  updateToken()
}

haxios.interceptors.request.use(
  async (config) => {
    updateToken() // Update token from localStorage
    if (!token) await getToken()
    config.headers.token = token
    config.headers.Authorization = `Bearer ${token}`

    if (!isAbsoluteURLRegex.test(config.url)) {
      if (!apir) throw new Error('Tried APIR req before APIR URL loaded')
      config.url = join(apir, config.url)
    }

    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

haxios.interceptors.response.use(
  (response) => {
    return response.data
  },
  async (error) => {
    //console.log(error)
    const originalRequest = error.config

    if (!error.response) {
      return Promise.reject(error)
    }

    if (error.response.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true
      await getToken()
      originalRequest.headers.token = token
      originalRequest.headers.Authorization = `Bearer ${token}`
      return haxios(originalRequest)
    }

    if (error.response.status === 401) {
      if (window.location.pathname !== '/login') window.location.href = '/login'
      return
    }

    return Promise.reject(error)
  }
)

export default haxios
